import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import propTypes from '../../common/prop-types';
import { SectionDetails } from '../../../shared/sectionable/styles';
import { attrs2month } from './utils';
import Name from './name';
import Highlights from './highlights';
import Returns from './returns';

const Container = styled(SectionDetails)`
  flex-direction: column;
  & > * {
    margin-bottom: ${props => (props.theme.isMobile ? 48 : 32)}px;
  }

  & > *:nth-child(1) {
    order: ${props => (props.theme.isMobile ? -1 : -2)};
  }

  & > *:nth-child(2) {
    order: ${props => (props.theme.isMobile ? -2 : -1)};
  }
`;

const Fees = styled.div`
  & > p {
    font: ${props => props.theme.fontWeightRegular} 16px/120% ${props => props.theme.fontFamilyBody};
    color: ${props => props.theme.secondaryColor};
    letter-spacing: 0.1px;
  }

  & > p.section-title{
    text-transform: uppercase;
    font-weight: ${props => props.theme.fontWeightHeavy};
    line-height: 16px;
    font-size: 14px;
  }
`;

export default function Details({ fund }) {
  const since = fund.inceptionDate;
  const perf = fund.performance.map(p => ({
    ...p,
    months: attrs2month[p.name],
    value: parseFloat(p.value),
  }));
  const oldest = _.reduce(
    fund.performance,
    (mom, p) => (mom.isAfter(p.updatedAt) ? moment(p.updatedAt) : mom),
    moment(),
  ).format('DD MMM YYYY');

  return (
    <Container>
      <Highlights perf={perf} attrs={[1, 12, Infinity]} since={since} />
      <Name name={_.get(fund, 'name')} perfUpdateDate={oldest} />
      <Returns perf={perf} since={since} />
      <Fees>
        <p>Past performance is not a guarantee of future results.</p>
        <p>Performance data has been provided by Morningstar.</p>
      </Fees>
    </Container>
  );
}

/* eslint-disable-next-line react/require-default-props */
Details.propTypes = { fund: propTypes.fund };
